import { APICompsSchema } from "@unit/apis";
import { FirestoreDataConverter, DocumentData, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export const INFLUENCER_PATH = "influencers";
export const NOTIFICATION_PATH = "notifications";

export type NotificationType = { id: APICompsSchema["UUIDValue"] } & APICompsSchema["FirestoreNotificationObject"];

export const notificationConverter: FirestoreDataConverter<NotificationType> = {
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): NotificationType {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      influencerId: data.influencerId,
      type: data.type,
      email: data.email,
      store: data.store,
      influencerTicket: data.influencerTicket,
      title: data.title,
      body: data.body,
      openedAt: data.openedAt ? Math.round(data.openedAt) : null,
      createdAt: Math.round(data.createdAt || 0),
      updatedAt: Math.round(data.updatedAt || 0),
    };
  },
  toFirestore(notification: NotificationType): DocumentData {
    return {
      id: notification.id,
      influencerId: notification.influencerId,
      type: notification.type,
      email: notification.email || null,
      store: notification.store || null,
      influencerTicket: notification.influencerTicket || null,
      title: notification.title,
      body: notification.body,
      openedAt: notification.openedAt ? Math.round(notification.openedAt) : null,
      createdAt: Math.round(notification.createdAt || 0),
      updatedAt: Math.round(notification.updatedAt || 0),
    };
  },
};
